import React, { useEffect, useLayoutEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style-page-aicall.css';
import '../Style/typo.css'
import banneraicall from "./assets/image/banner-aicall.png";
import voicetotext from "./assets/image/voice-to-text.png";
import callsummary from "./assets/image/call-summary.png";
import calltranslate from "./assets/image/call-translate.png";
import noteai from "./assets/image/note-ai.png";
import integrationSync from "./assets/image/integration-sync.png";
import ui360 from "./assets/image/UI-360.png";
import optimizeworkflow from "./assets/image/optimize-workflow.png";
import steptouse from "./assets/image/step-to-use.png";
import vector4 from "./assets/image/vector-4.png";
import HeaderVn from "../detailpageVN/Page/component/headervn";
import FooterVn from "../detailpageVN/Page/component/footervn";

function AICall() {
    useEffect(() => {
        // Hide menu desktop
        document.querySelectorAll('.navbar-nav, .navbar-item').forEach(el => {
            el.style.display = 'none';
        });
        // Hide menu mobile (sidebar, collapse)
        document.querySelectorAll('.sidebar-menu, #collapse-header .navbar-list ul').forEach(el => {
            el.style.display = 'none';
        });
        // Keep logo, button and selectbox language
        document.querySelectorAll('.head-drop-sub, .header-vn-mb .head-drop-sub').forEach(el => {
            el.style.display = 'block';
        });
        document.querySelectorAll('.nav-vn > a, .header-vn-mb .nav-vn > a').forEach(el => {
            el.style.display = 'inline-block';
        });
        document.querySelectorAll('.icon-menu, .head-dropdown button').forEach(el => {
            el.style.display = 'inline-flex';
        });
    }, []);
    return (
        <div className="container-aicall">
            <HeaderVn />
            <div className="container-aicall-content">
                {/* Banner section */}
                <div className="aicall-banner-gradient">
                    <div className="aicall-banner-content">
                        <div className="aicall-banner-content-left">
                            <h1 class="typo-32-mb aicall-title">
                               Tối ưu giao tiếp - Nâng tầm quản lý khách hàng với Tổng Đài AI thông minh
                            </h1>
                            <p class="typo-21-sm aicall-desc">
                                AI Call không chỉ là tổng đài. Chúng tôi tích hợp trí tuệ nhân tạo (AI) thông qua hạ tầng LLM tuỳ chỉnh để tự động hóa, tối ưu hóa và biến mọi tương tác với khách hàng thành tài sản giá trị, đồng bộ liên mạch với <b>Hanbiro Groupware & Helpdesk</b>.
                            </p>
                            <button className="typo-16 typo-medium aicall-register-btn"><a class="ai-call-btn-url" href="mailto:vina@hanbiro.com, groupware@hanbiro.com">Tư vấn miễn phí</a></button>
                        </div>
                        <div className="aicall-banner-img">
                            <img src={banneraicall} />
                        </div>
                    </div>                    
                </div>
                {/* Solution section */}
                <div className="aicall-solution-box">
                    <div className="aicall-solution-box-content">
                        <p className="typo-21 typo-medium solution-title">Bạn đang tìm kiếm giải pháp cho doanh nghiệp?</p>
                        <ul className="typo-16 solution-list">
                            <li>Mất quá nhiều thời gian ghi chú thủ công sau mỗi cuộc gọi</li>
                            <li>Khó khăn trong việc theo dõi, phân tích và khai thác dữ liệu từ các cuộc trò chuyện</li>
                            <li>Muốn nâng cao chất lượng dịch vụ nhưng chưa tìm được công cụ phù hợp</li>
                        </ul>
                    </div>
                    <div className="aicall-solution-function">
                        <p class="typo-32 solution-tile"><a class="aicall-text">AI Call</a> chính là giải pháp bạn cần!</p>
                        <p class="typo-16">Khám phá các tính năng nổi bật của hệ thống tổng đài thông minh, tích hợp trí tuệ nhân tạo (AI) đột phá, <br></br>giúp bạn tự động hóa, tối ưu hóa và biến mọi tương tác với khách hàng thành tài sản giá trị.</p>
                    </div>
                    <div className="aicall-solution-function-box">
                        <div className="aicall-solution-function-box-content">
                            <img src={voicetotext} alt="Voice to Text" />
                            <p class="typo-21 typo-medium">Phiên âm cuộc gọi<br />(Voice-to-Text)</p>
                        </div>
                        <div className="aicall-solution-function-box-content">
                            <img src={callsummary} alt="Voice to Text" />
                            <p class="typo-21 typo-medium">Tóm tắt cuộc gọi<br />(Call Summary)</p>
                        </div>
                        <div className="aicall-solution-function-box-content">
                            <img src={calltranslate} alt="Voice to Text" />
                            <p class="typo-21 typo-medium">Dịch thuật cuộc gọi<br />(Call Translation)</p>
                        </div>
                        <div className="aicall-solution-function-box-content">
                            <img src={noteai} alt="Voice to Text" />
                            <p class="typo-21 typo-medium">Giao việc thông minh<br />(Smart Assignment)</p>
                        </div>
                    </div>
                </div>
                <div className="aicall-integration-sync">
                    <div className="aicall-integration-sync-section">
                        <div className="aicall-integration-sync-title">
                            <p className="typo-32">Tích hợp và đồng bộ <a class="aicall-text">HelpDesk</a></p>
                        </div>
                        <div className="aicall-integration-sync-box">
                            <div className="aicall-integration-sync-content">
                                <p className="typo-21 typo-medium title-integration-sync">
                                    Tích hợp và đồng bộ dữ liệu
                                </p>
                                <p class="typo-16 description">
                                    AI Call đồng bộ dữ liệu cuộc gọi, ghi chú và các tính năng AI khác trực tiếp 
                                    vào menu Helpdesk trên nền tảng Hanbiro Groupware.
                                </p>
                                <ul className="typo-16">
                                    <li>Nhật ký cuộc gọi</li>
                                    <li>Tệp ghi âm</li>
                                    <li>Nội dung trao đổi</li>
                                    <li>Danh sách cuộc gọi nhỡ</li>                                
                                    <li>Nội dung tóm tắt AI</li>
                                </ul>
                                <button class="typo-16 typo-medium aicall-integration-sync-btn"><a class="ai-call-btn-url" href="https://hanbiro.vn/groupware-free-trial">Dùng thử ngay</a></button>
                            </div>
                            <div className="aicall-integration-sync-content-img">
                                <img src={integrationSync} alt="Integration Sync" />
                            </div>
                        </div>
                        <div className="aicall-integration-sync-box">
                            <div className="aicall-integration-sync-content">
                                <p className="typo-21 typo-medium title-integration-sync">
                                    Giao diện khách hàng 360 độ
                                </p>
                                <p class="typo-16 description">
                                    Dễ dàng truy cập toàn bộ lịch sử tương tác, ticket, thông tin khách hàng 
                                    trên một giao diện thống nhất, từ đó đưa ra quyết định nhanh chóng và chính xác.
                                </p>
                                <ul className="typo-16">
                                    <li>Thông tin khách hàng</li>
                                    <li>Lịch sử tương tác</li>
                                    <li>Nội dung ticket</li>                                
                                    <li>Thông tin người phụ trách</li>
                                </ul>
                                <button class="typo-16 typo-medium aicall-integration-sync-btn"><a class="ai-call-btn-url" href="https://hanbiro.vn/groupware-free-trial">Dùng thử ngay</a></button>
                            </div>
                            <div className="aicall-integration-sync-content-img">
                                <img src={ui360} alt="UI 360" />
                            </div>
                        </div>
                        <div className="aicall-integration-sync-box mb-0">
                            <div className="aicall-integration-sync-content">
                                <p className="typo-21 typo-medium title-integration-sync">
                                    Luồng công việc liền mạch
                                </p>
                                <p class="typo-16 description">
                                    Đồng bộ hóa Quản lý cuộc gọi và dữ liệu từ điện thoại sang website -<br /> không gián đoạn quy trình.
                                </p>
                                <ul className="typo-16">
                                    <li>Kết nối dữ liệu khách hàng</li>
                                    <li>Cập nhật thông tin cuộc gọi</li>
                                    <li>Tích hợp danh sách ticket</li>                              
                                    <li>Lưu lại toàn bộ lịch sử tương tác</li>
                                </ul>
                                <button class="typo-16 typo-medium aicall-integration-sync-btn"><a class="ai-call-btn-url" href="https://hanbiro.vn/groupware-free-trial">Dùng thử ngay</a></button>
                            </div>
                            <div className="aicall-integration-sync-content-img">
                                <img src={optimizeworkflow} alt="Optimize Workflow" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="aicall-step-to-use">
                    <div className="aicall-step-to-use-title">
                        <p class="typo-32">3 Bước sử dụng <a class="aicall-text">AI Call</a></p>
                    </div>
                    <div className="aicall-step-to-use-box">
                        <div className="aicall-step-to-use-content">
                            <div class="aicall-step">
                                <div class="aicall-circle typo-16">1</div>
                                <div class="aicall-content">
                                    <p class="typo-21 typo-medium typo-black title-box">Thực hiện cuộc gọi</p>
                                    <p class="typo-16">Thực hiện và nhận cuộc gọi trực tiếp từ ứng dụng di động. Ghi chú nhanh, tạo tác vụ ngay khi đang gọi.</p>
                                </div>
                            </div>
                            <div class="aicall-step">
                                <div class="aicall-circle typo-16">2</div>
                                <div class="aicall-content">
                                    <p class="typo-21 typo-medium title-box">AI tự động xử lý và đồng bộ</p>
                                    <p class="typo-16">AI tự động phiên âm, tóm tắt, dịch cuộc gọi. Toàn bộ dữ liệu được đồng bộ liền mạch với HelpDesk trên Hanbiro Groupware.</p>
                                </div>
                            </div>
                            <div class="aicall-step mb-0">
                                <div class="aicall-circle typo-16">3</div>
                                <div class="aicall-content">
                                    <p class="typo-21 typo-medium title-box">Quản lý và Khai thác</p>
                                    <p class="typo-16">Truy cập Hanbiro HelpDesk qua trình duyệt web để quản lý khách hàng, theo dõi lịch sử, phân tích dữ liệu và xử lý ticket.</p>
                                </div>
                            </div>
                        </div>
                        <div className="aicall-step-to-use-img">
                            <img src={steptouse} alt="Step to Use" />
                        </div>
                    </div>
                </div>
                <div class="aicall-suitable-for">
                    <div class="aicall-suitable-for-box">
                        <div class="aicall-suitable-for-title">
                            <p class="typo-32">AI Call phù hợp
                            với doanh nghiệp nào?</p>
                        </div>
                        <div class="aicall-suitable-for-content">
                            <div class="aicall-suitable-for-sub-content">
                                <div class="icon typo-16"><img src={vector4} alt="Vector" /></div>
                                <div class="item">
                                    <p class="typo-21-sm typo-medium item-title">Doanh nghiệp vừa và nhỏ (SMEs)</p>
                                    <p class="typo-16 item-desc">Đang tìm kiếm giải pháp tổng đài hiện đại, thông minh với chi phí hợp lý.</p>
                                </div>
                            </div>
                            <div class="aicall-suitable-for-sub-content">
                                <div class="icon typo-16"><img src={vector4} alt="Vector" /></div>
                                <div class="item">
                                    <p class="typo-21-sm typo-medium item-title">Đội ngũ Sales & Marketing</p>
                                    <p class="typo-16 item-desc">Muốn quản lý leads hiệu quả, theo dõi tương tác khách hàng và nâng cao tỷ lệ chốt sales.</p>
                                </div>
                            </div>
                            <div class="aicall-suitable-for-sub-content">
                                <div class="icon typo-16"><img src={vector4} alt="Vector" /></div>
                                <div class="item">
                                    <p class="typo-21-sm typo-medium item-title">Bộ phận Chăm sóc khách hàng </p>
                                    <p class="typo-16 item-desc">Cần công cụ để nâng cao chất lượng dịch vụ, xử lý yêu cầu nhanh chóng và hiệu quả..</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ai-call-faq-section">
                    <div class="faq-title">
                        <span class="typo-32 typo-medium">Các Câu Hỏi Thường Gặp (FAQs)</span>
                    </div>
                    <div class="accordion faq-accordion-cd" id="accordionFaQ">
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                >
                                    AI Call là gì? Nó khác gì so với các ứng dụng tổng đài khác trên thị trường?
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse typo-16 collapse show" data-bs-parent="#accordionFaQ">
                                <div class="accordion-body">
                                    <span>
                                       AI Call là ứng dụng tổng đài di động do Hanbiro Vietnam phát triển dựa trên SDK của
                                        Tổng đài ảo Voip24h. AI Call tích hợp các tính năng cơ bản của tổng đài gói Busscall của
                                        Voip24h và tích hợp tính năng AI khác. Sự khác biệt chính là AI Call có khả năng chuyển
                                        đổi giọng nói thành văn bản (Voice-to-Text), tóm tắt cuộc gọi (Summary Callings) và dịch
                                        cuộc gọi (Translate Callings). Đặc biệt, nó tích hợp sâu và liền mạch với hệ thống Hanbiro
                                        Helpdesk và Groupware, tạo thành một giải pháp quản lý khách hàng và công việc toàn
                                        diện, mà các ứng dụng tổng đài thông thường không có. 
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                    aria-expanded="false"
                                    aria-controls="collapseTwo"
                                >
                                    Có cần phải sử dụng Hanbiro Groupware mới dùng được AI Call không?
                                </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionFaQ">
                                <div class="accordion-body">
                                    <span>
                                        Để khai thác tối đa sức mạnh của AI Call và các tính năng AI được hiển thị trên hệ thống,
                                        doanh nghiệp của bạn cần phải đăng ký và sử dụng dịch vụ Hanbiro Groupware (gói Mail
                                        hoặc Groupware). AI Call được thiết kế để hoạt động hiệu quả nhất khi đồng bộ dữ liệu
                                        với Hanbiro Helpdesk trên nền tảng Groupware, giúp bạn quản lý khách hàng và tương tác
                                        tập trung trên một hệ thống duy nhất.
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree"
                                    aria-expanded="false"
                                    aria-controls="collapseThree"
                                >
                                    Tôi có cần đăng ký dịch vụ của bên thứ ba nào khác để sử dụng AI Call không?
                                </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionFaQ">
                                <div class="accordion-body">
                                    <span>
                                        Có. Để sử dụng AI Call, bạn cần đăng ký dịch vụ của Voip24h bao gồm sử dụng đầu số
                                        SIP và tổng đài của Voip24h, cụ thể là gói Business của BussCall. Chúng tôi sẽ hỗ trợ bạn
                                        từ việc tư vấn đăng kí và làm việc với Voip24h.
                                        <br />Điều này đảm bảo bạn có quyền truy cập trang quản lý tổng đài để cung cấp các thông tin
                                        cấu hình cần thiết (địa chỉ SIP, API Key, API Secret) cho hệ thống Hanbiro Groupware.
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseFor"
                                    aria-expanded="false"
                                    aria-controls="collapseFor"
                                >
                                    Các tính năng AI (Voice-to-Text, Tóm tắt, Dịch) hoạt động như thế nào và có chính xác không?
                                </button>
                            </h2>
                            <div id="collapseFor" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionFaQ">
                                <div class="accordion-body">
                                    <span>
                                        Các tính năng AI trong AI Call sử dụng công nghệ xử lý ngôn ngữ tự nhiên (NLP) tiên tiến để phân tích và xử lý nội dung cuộc gọi.
                                    </span>
                                    <ul>
                                        <li>
                                            Voice-to-Text: Chuyển đổi giọng nói thành văn bản với độ chính xác cao.
                                        </li>
                                        <li>
                                            Tóm tắt cuộc gọi: AI sẽ phân tích và trích xuất các điểm chính, ý chính, 
                                            quyết định hoặc hành động cần thiết từ cuộc hội thoại.
                                        </li>
                                        <li> 
                                            Dịch cuộc gọi: Hỗ trợ dịch thuật theo thời gian thực hoặc sau cuộc gọi để giúp bạn
                                            hiểu nội dung bằng ngôn ngữ mong muốn. Mức độ chính xác có thể thay đổi tùy
                                            thuộc vào chất lượng âm thanh, tốc độ nói và ngữ điệu, nhưng chúng tôi liên tục cải
                                            thiện thuật toán để tối ưu hiệu quả.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive"
                                    aria-expanded="false"
                                    aria-controls="collapseFive"
                                >
                                    Dữ liệu cuộc gọi và thông tin khách hàng của tôi có được bảo mật không?
                                </button>
                            </h2>
                            <div id="collapseFive" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionFaQ">
                                <div class="accordion-body">
                                    <span>
                                        Tuyệt đối bảo mật! Hanbiro Vietnam cam kết bảo vệ dữ liệu của khách hàng. Mọi thông tin
                                        cuộc gọi, dữ liệu khách hàng và các bản ghi AI đều được lưu trữ an toàn trên hệ thống
                                        Groupware của Hanbiro với các tiêu chuẩn bảo mật cao nhất, đảm bảo tính riêng tư và toàn
                                        vẹn dữ liệu cho doanh nghiệp bạn
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseSix"
                                    aria-expanded="false"
                                    aria-controls="collapseSix"
                                >
                                    Quy trình triển khai AI Call có phức tạp không? Mất bao lâu?
                                </button>
                            </h2>
                            <div id="collapseSix" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionFaQ">
                                <div class="accordion-body">
                                    <span>
                                       Quy trình triển khai AI Call được thiết kế để đơn giản và nhanh chóng. Sau khi bạn đăng
                                        ký các dịch vụ cần thiết (Voip24h BussCall Business và Hanbiro Groupware), đội ngũ kỹ
                                        thuật của Hanbiro sẽ hướng dẫn chi tiết cách cấu hình và tích hợp. Thời gian triển khai cụ
                                        thể sẽ phụ thuộc vào quy mô và yêu cầu tùy chỉnh của doanh nghiệp bạn, nhưng chúng tôi
                                        cam kết hỗ trợ bạn từ A đến Z. Hãy liên hệ 18006346 miễn phí hoặc email về
                                        vina@hanbiro.com và để lại số điện thọai, chúng tôi sẽ liên hệ ngay khi nhận được thông tin.
                                        Chúng tôi sẽ tiếp nhận yêu cầu và tư vấn, xử lý cùng bạn từ khâu đăng kí và chốt dịch vụ
                                        liên quan đến voip24h.
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseSeven"
                                    aria-expanded="false"
                                    aria-controls="collapseSeven"
                                >
                                    AI Call có hỗ trợ trên cả Android và iOS không?
                                </button>
                            </h2>
                            <div id="collapseSeven" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionFaQ">
                                <div class="accordion-body">
                                    <span>
                                       Vâng, ứng dụng AI Call được phát triển để hoạt động trên cả hai nền tảng di động phổ
                                        biến là Android và iOS, giúp đội ngũ của bạn linh hoạt sử dụng trên thiết bị cá nhân của mình.
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div class="divider-line"></div> */}
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button typo-16 question collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseEight"
                                    aria-expanded="false"
                                    aria-controls="collapseEight"
                                >
                                    Tôi có thể dùng thử AI Call trước khi quyết định đăng ký không?
                                </button>
                            </h2>
                            <div id="collapseEight" class="accordion-collapse typo-16 collapse" data-bs-parent="#accordionFaQ">
                                <div class="accordion-body">
                                    <span>
                                        Để trải nghiệm trọn vẹn các tính năng của AI Call và sự tích hợp với Hanbiro Helpdesk,
                                        chúng tôi khuyến khích bạn liên hệ với đội ngũ Sales của chúng tôi để được tư vấn chi tiết
                                        và sắp xếp một buổi demo sản phẩm thực tế. Chúng tôi sẽ giúp bạn thấy rõ AI Call có thể
                                        thay đổi cách doanh nghiệp bạn hoạt động như thế nào.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ai-call-register-section">
                    <div class="ai-call-register-content bottom-cta">
                        <div class="register-content">
                            <p class="typo-32 typo-medium typo-white mb-2">Bạn đã sẵn sàng nâng tầm doanh nghiệp mình?</p>
                            <p class="typo-16 typo-white">Đừng để những cuộc gọi hàng ngày chỉ là những cuộc trò chuyện đơn thuần.</p> 
                            <p class="typo-16 typo-white">Hãy biến chúng thành tài sản quý giá, thúc đẩy năng suất và tăng trưởng doanh thu với AI Call!</p>
                        </div>
                        <div>
                            <div class="typo-16 typo-medium typo-white ai-call-register-trial-button"><a class="ai-call-btn-url" href="https://hanbiro.vn/groupware-free-trial">Đăng ký dùng thử ngay</a></div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterVn />
        </div>
    )
}

export default AICall;